/* global M4CGlobal, $, MatgenGlobal, mg, bootstrap, API_ENV, TENANT_ENV */
// @ts-nocheck

import { Loaders } from './m4c-loaders';
import {
  API,
  Auth,
  Storage,
  Cache,
  Logger,
  Hub,
  ServiceWorker,
} from 'aws-amplify';
import { Router } from './core/router/router-navigo.js';
import M4CAmplify from './m4c-amplify/M4CAmplify.js';
import M4CAmplifyUser from './m4c-amplify/M4CAmplifyUser.js';
import LoaderManager from './m4c-loader/M4CLoaderManager.js';
import { MatgenData } from './core/api/matgen-data.js';
import { M4CModal } from './m4c-modal/M4CModal.js';
import { emit } from './matgen-ui/common/helpers.js';
import { UI } from './matgen-ui/ui.js';
import { init as baseInit } from './matgen-ui/client/events/base-events.js';
import kleur from 'kleur';

const cliStyle = kleur;

const formatBytes = bytes => {
  if (bytes < 1024) {
    return `${bytes} Bytes`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  } else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
};

const getStorageUsage = async () => {
  const estimate = await navigator.storage.estimate();
  const quota = estimate.quota;
  const usage = estimate.usage;
  return {
    quota,
    usage,
    avail: formatBytes(quota),
    used: formatBytes(usage),
    usedPercent: Math.round(estimate.usage / estimate.quota / 10000, 4) * 10000,
  };
};

const toastIcons = {
  starExclamation: `<i class="fa-solid fa-star-exclamation fa-lg"></i>`,
  defaultBlueSquare: `
  <svg class="bd-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false"><rect width="100%" height="100%" fill="#007aff"></rect></svg>
  `,
};

const toastHeader = (title, subtext) => `
  ${toastIcons.starExclamation}
  <strong class="me-auto">${title}</strong>
  <small>${subtext}</small>
  <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"><i class="fa-solid fa-square-xmark"></i></button>
`;

const toast = ({ selector, header = '', message = '' }) => {
  const toastEl = $(`
    <div id="${selector.replace(
      '#',
      ''
    )}" class="toast" role="alert" data-bs-delay="100000" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        ${header}
      </div>
      <div class="toast-body">
        ${message}
      </div>
    </div>
  `);
  $('#toast-container').append(toastEl);
  const bsToast = bootstrap.Toast.getOrCreateInstance($(selector)[0]);
  bsToast.show();
  /*$(selector).on('hidden.bs.toast', () => {
    bsToast.dispose();
  });*/
};

const InitMatgenCore = () => {
  if (typeof MatgenGlobal === 'undefined') {
    const MatgenGlobal = {};
    window.MatgenGlobal = MatgenGlobal;
  }

  if (typeof mg === 'undefined') {
    const mg = {};
    window.mg = mg;
  }

  if (typeof M4CGlobal === 'undefined') {
    window.M4CGlobal = {};
  }

  MatgenGlobal.Data = new MatgenData();
  MatgenGlobal.Cache = Cache;
  MatgenGlobal.log = new Logger('matgen-core', 'VERBOSE');
  MatgenGlobal.Hub = Hub;
  MatgenGlobal.ServiceWorker = ServiceWorker;
  mg.log = MatgenGlobal.log;
  MatgenGlobal.toast = toast;
  mg.toast = MatgenGlobal.toast;
  MatgenGlobal.toastHeader = toastHeader;
  mg.toastHeader = MatgenGlobal.toastHeader;
  MatgenGlobal.cliStyle = cliStyle;
  mg.cliStyle = cliStyle;

  //mg.log.error(cli.red().bold('Error message here'), MatgenGlobal);

  getStorageUsage().then(usage => {
    MatgenGlobal.storageUse = usage;
  });

  /*mg.toast({
    selector: '#test-toast',
    header: toastHeader('Bootstrap', '11 mins ago'),
    message: 'Hello, world! This is a toast message.',
    autoHide: false,
  });*/

  const api_env = API_ENV === 'production' ? 'prod' : 'dev';
  const tenant_env = TENANT_ENV ? TENANT_ENV : 'm4c';

  M4CGlobal.Matgen = MatgenGlobal;

  if (!MatgenGlobal.Amplify) {
    MatgenGlobal.Amplify = {
      Auth,
      Storage,
      API,
      Cache,
      Logger,
      Hub,
      ServiceWorker,
    };
  }

  MatgenGlobal.api_env = api_env;
  MatgenGlobal.tenant_env = tenant_env;
  MatgenGlobal.UI = UI;

  MatgenGlobal.LoaderManager = new LoaderManager();

  const fullScreenLoader = new Loaders.FullScreenLoader({
    anim: 'dualRing',
    bgfxSelector: '#matgen-whole',
    messageSelector: '#m4c-fullscreen-loader-message',
    scope: 'matgen-fullscreen-loader',
    transition: 'grayscale 2s, brightness 2s, blur 2s',
    filter: 'grayscale(100%) brightness(.95) blur(3px)',
  });

  const MatgenPageLoader = MatgenGlobal.LoaderManager.addLoader({
    loader: fullScreenLoader,
    id: 'matgen-loader',
    //debug: true,
  });

  MatgenGlobal.MatgenPageLoader = MatgenPageLoader;

  MatgenGlobal.emit = emit;
  MatgenGlobal.M4CModal = M4CModal;
  MatgenGlobal.Router = new Router();
  MatgenGlobal.AuthUserModule = M4CAmplifyUser;
  MatgenGlobal.CurrentAPIRequests = [];
  MatgenGlobal.CurrentS3Requests = [];

  MatgenGlobal.BaseInit = baseInit;

  MatgenGlobal.BaseInit();
  MatgenGlobal.hideTooltips = () => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    [...tooltipTriggerList].map(tooltipTriggerEl => {
      const tooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
      if (tooltip) {
        tooltip.hide();
      }
    });
  };

  MatgenGlobal.init = async ({
    token = false,
    identity_id = false,
    containerId = 'matgen-container',
    controllerTargetSelector = '#matgen-controller',
    sidebarTargetSelector = 'main',
    rootPage = 'index.html',
    gridColor = '#aaa',
    borderScale = 4,
    borderColor = '#FB1330',
    borderColorDarkened = '#c71f1f',
    editingBorderColor = '#00a9ff',
    scalingTargetId = 'matgen-scale-container-init-default',
    expiresIn = 60,
  } = {}) => {
    if (!MatgenGlobal.MatgenInitialized) {
      if (!MatgenGlobal.AMPLIFY_VARS) {
        throw new Error('Amplify module: Missing configuration.');
      }

      if (!MatgenGlobal.base_config) {
        MatgenGlobal.base_config = MatgenGlobal.AMPLIFY_VARS;
      }

      MatgenGlobal.MatgenAmplify = new M4CAmplify({
        AMPLIFY_VARS: MatgenGlobal.AMPLIFY_VARS,
      });

      MatgenGlobal.ContainerId = containerId;
      MatgenGlobal.ControllerTargetSelector = controllerTargetSelector;
      MatgenGlobal.SidebarTargetSelector = sidebarTargetSelector;
      MatgenGlobal.ScalingTargetId = scalingTargetId;
      if (!MatgenGlobal.RootPage) {
        MatgenGlobal.RootPage = rootPage;
      }
      MatgenGlobal.GridColor = gridColor;
      MatgenGlobal.BorderScale = borderScale;
      MatgenGlobal.BorderColor = borderColor;
      MatgenGlobal.BorderColorDarkened = borderColorDarkened;
      MatgenGlobal.EditingBorderColor = editingBorderColor;
      MatgenGlobal.ExpiresIn = expiresIn;
      MatgenGlobal.StateId = 0;
      MatgenGlobal.PreviousStateId = 0;

      M4CGlobal.SHOW_DUPE_COUNT = true;

      new M4CAmplifyUser(token, identity_id);

      let user;
      if (!MatgenGlobal.AuthUser) {
        MatgenGlobal.AuthUser = new MatgenGlobal.AuthUserModule();
      }
      if (MatgenGlobal.AuthUser.user) {
        user = MatgenGlobal.AuthUser.user;
      } else {
        if (navigator.onLine) {
          user = MatgenGlobal.AuthUser
            ? await MatgenGlobal.AuthUser.getUser()
            : false;
          if (!user) {
            MatgenGlobal.AuthUser = new MatgenGlobal.AuthUserModule();
            await MatgenGlobal.AuthUser.getUser();
          }
        }
      }

      emit({
        event: 'matgen-ready',
      });

      MatgenGlobal.MatgenInitialized;
    }
  };
};

export default InitMatgenCore;
